import type { FabMenuOptionId, TabType } from '@hunting-nature/shared-core/enums/tab-bar.enum';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { createScopedSelector } from '../../utils/factory.utils';

import { GeneralActions } from '../general/general.actions';
import { getMenuConfigForTab } from './tab-bar-menu.data';
import { TabBarActions } from './tab-bar.actions';

export const TAB_BAR_STORE_KEY = 'tabBar';

export interface TabBarState {
  tabBarMenuOpen: boolean;
  activeTab: TabType | undefined;
  expandedOptionId: FabMenuOptionId | null;
}

export const initialTabBarState: TabBarState = {
  tabBarMenuOpen: false,
  activeTab: undefined,
  expandedOptionId: null,
};

const selectTabBarState = createFeatureSelector<TabBarState>(TAB_BAR_STORE_KEY);
const createTabBarSelector = createScopedSelector(selectTabBarState);

export const tabBarReducer = createReducer(
  initialTabBarState,

  on(TabBarActions.toggleTabBarMenu, state => ({
    ...state,
    tabBarMenuOpen: !state.tabBarMenuOpen,
    expandedOptionId: null,
  })),
  on(TabBarActions.openTabBarMenu, state => ({
    ...state,
    tabBarMenuOpen: true,
  })),
  on(TabBarActions.closeTabBarMenu, state => ({
    ...state,
    tabBarMenuOpen: false,
    expandedOptionId: null,
  })),
  on(TabBarActions.expandOption, (state, { optionId }) => ({
    ...state,
    tabBarMenuOpen: true,
    expandedOptionId: optionId,
  })),
  on(TabBarActions.collapseOption, state => ({
    ...state,
    tabBarMenuOpen: false,
    expandedOptionId: null,
  })),
  on(TabBarActions.selectTab, (state, { tab }) => ({
    ...state,
    activeTab: tab,
    tabBarMenuOpen: false,
    expandedOptionId: null,
  })),
  on(TabBarActions.syncActiveTabFromRoute, (state, { tab }) => (state.activeTab === tab ? state : { ...state, activeTab: tab })),
  on(GeneralActions.menuOpened, state => ({
    ...state,
    tabBarMenuOpen: false,
    expandedOptionId: null,
  }))
);

export const TabBarSelectors = {
  tabBarMenuOpen: createTabBarSelector(state => state.tabBarMenuOpen),

  // Dynamic options based on active tab
  menuConfig: createTabBarSelector(state => getMenuConfigForTab(state.activeTab)),

  // Generic expanded card – null means no card is expanded
  expandedOptionId: createTabBarSelector(state => state.expandedOptionId),
};
